import {
    SLA_CREATE,
    SLA_LIST,
    SLA_UPDATE,
    UNIT_LIST
} from "../actions";

export function sla(currentState = {}, action) {
    switch (action.type) {
        case SLA_CREATE:
            return {
                type: action.type,
                list: currentState.list ? currentState.list.concat(action.list) : [action.list]
            }
        case SLA_LIST:
            return currentState = action
        case SLA_UPDATE:
            return {
                type: action.type,
                list:  currentState.list.map(current => current.id  === action.list.id ? action.list : current)
            }
        default:
            return currentState
    }
}

export function unitTime(currentState = {}, action){
      if(action.type === UNIT_LIST){
         return currentState = action
      }
      return currentState
}